<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: "all",
  },
  options: {
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    default: "Filter by trade",
  },
});

const emit = defineEmits(["update:modelValue"]);

const updateValue = (val) => {
  emit("update:modelValue", val);
};
</script>

<template>
  <div class="filter-select">
    <select class="form-select" :value="modelValue" @change="(e) => updateValue(e.target.value)">
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<style scoped>
.filter-select {
  width: 100%;
}
</style>
